<template>
    <div>
        <div class="row">
            <div class="col-8">
                <div class="text-left section-title" style="padding: 5px;">
                    <span class="row-table-font-margins" style='font-family: inherit; font-weight: 600 ; line-height: 1; text-align:center'>
                        <template v-if="buildingId">
                            <span row-table-font-margins style='font-family: inherit; font-weight: 600 ; line-height: 1; text-align:center;'> {{ buildingName}} / </span>
                        </template>
                        Units
                    </span>
                </div>
            </div>
            <div class="col-4 add-button-section">
                <div class="text-right" style="padding: 5px;">
                    <!--<span style="margin-right:5px">Add New Unit</span>
            <router-link class="btn btn-table" :to="{
      name: 'property',
      params: { buildingId: buildingId, buildingName: buildingName },
    }"><i class="fas fa-plus"></i></router-link>-->
                    <span style="
width: 30px;
height: 30px;
border-radius: 5px;
            background-color: #007DFC;
            color: white;
            display: inline-block;
            padding-left: 5px;
            padding-right: 5px;
            text-align: center;
            margin-right:8px;
          ">
                        <i class="fa fa-sliders-h" style="margin-top:7px;transform: rotate(-90deg);" aria-hidden="true"></i>
                    </span>

                    <span @click="showSearch()"
                          style="
                          width: 30px;
                          height: 30px;
                          border-radius: 5px;
                          background-color: #007DFC;
                          color: white;
                          display: inline-block;
                          padding-left: 5px;
                          padding-right: 5px;
                          text-align: center;
                          cursor:pointer;

                          ">
                        <i class="fa fa-search" style="margin-top:7px;" aria-hidden="true"></i>
                    </span>
                    <input type="text" v-if="visibleSearch" class="form-control" name="searchText" id="searchText" style=" display: inline-block; width: 250px; height: 30px;" v-model="filter">
                    <userMenu />
                </div>
            </div>
           
        </div>
    

    <div class="row">

        <div class="offset-md-9 col-3 add-button-section">
            <div class="text-right" style="padding: 5px;">
                <span style="margin-right:5px">Add New Unit</span>
                <router-link class="btn btn-table" :to="{
            name: 'property',
            params: { buildingId: buildingId, buildingName: buildingName },
          }"><i class="fas fa-plus"></i></router-link>
            </div>
        </div>
    </div>

    <div v-if="false" class="row" style="margin-left: 1px;">
        <div class="pull-left col-lg-3 col-md-3 col-sm-5 col-12"
             style="padding-left: 0; display: inline-flex;">
            <div class="size">
                Show
                <select class="size-select" v-model="size">
                    <option value="10">10</option>
                    <option value="20">20</option>
                    <option value="50">50</option>
                </select>
                Entries
            </div>
        </div>

        <div class="sortBy col-lg-3 col-md-3 col-sm-5 col-12"
             style="margin-bottom: 20px;">
            Sort By
            <select class="sortBy-select" v-model="sortBy">
                <option value="Name">Name</option>
                <option value="ContactName">Contact Name</option>
            </select>
        </div>

        <div class="search col-lg-3 col-md-3 col-sm-4 col-6"
             style="width: 190px; margin-top: 12px;">
            <span class="fa fa-search"></span>
            <input type="text"
                   class="form-control"
                   name="searchText"
                   id="searchText"
                   placeholder="Search Unit..."
                   v-model="filter" />
        </div>

        <div class="col-lg-3 col-md-3 col-sm-4 col-6 pull-right"
             style="margin-bottom: 10px; text-align: right;">
            <router-link class="btn btn-primary"
                         :to="{
            name: 'property',
            params: { buildingId: buildingId, buildingName: buildingName },
          }">
                <div class="board-add">Add unit</div>
            </router-link>
        </div>
    </div>
    <div class="table-responsive">
        <table class="table table-condensed">
            <thead>
                <tr>

                    <th scope="col">Floor / Number</th>
                    <th scope="col">Type</th>
                    <th scope="col">Square Meters</th>
                    <th scope="col">Monthly Fee</th>
                    <th scope="col">Balance</th>
                    <th scope="col">Name</th>
                    <th scope="col">Email</th>
                    <th scope="col">Phone Number</th>

                    <th>

                    </th>
                    <!-- <th colspan="4" class="text-center">Actions</th>-->
                </tr>
            </thead>
            <tbody style="background-color: #fff;">
                <template v-for="property in paginatedData" :key="property">
                    <tr
                        class="clickable-row"
                        v-bind:class="{ 'min-row-height45': !property.isSelected }">

                        <td class="clickable-column">
                            <a @click.prevent="selectProperty(property)">{{ property.floor }} / {{ property.number }}</a>
                        </td>
                        <td class="clickable-column">
                            <a @click.prevent="selectProperty(property)">
                                {{
                  property.typeName
                                }}
                            </a>
                        </td>
                        <td class="clickable-column">
                            <a @click.prevent="selectProperty(property)">
                                {{
                  property.squareMeters
                                }}
                            </a>
                        </td>
                        <td class="clickable-column">
                            <a @click.prevent="selectProperty(property)">
                                {{ $filters.toCurrency(property.monthlyFee) }}
                            </a>
                        </td>
                        <td class="clickable-column">
                            <a @click.prevent="selectProperty(property)">
                                {{ $filters.toCurrency(property.balance) }}
                            </a>
                        </td>
                        <td scope="row" class="clickable-column" v-if="property.contact">
                            <a @click.prevent="selectProperty(property)">
                                {{
                  property.contact.name
                                }}
                            </a>
                        </td>
                        <td class="clickable-column" v-else>
                            <a @click.prevent="selectProperty(property)"></a>
                        </td>
                        <td class="clickable-column" v-if="property.contact">
                            <a @click.prevent="selectProperty(property)">
                                {{
                  property.contact.email
                                }}
                            </a>
                        </td>
                        <td class="clickable-column" v-else>
                            <a @click.prevent="selectProperty(property)"></a>
                        </td>
                        <td class="clickable-column" v-if="property.contact">
                            <a @click.prevent="selectProperty(property)">
                                {{ property.contact.phoneNumber }}
                            </a>
                        </td>

                        <td class="clickable-column" v-else>
                            <a @click.prevent="selectProperty(property)"></a>
                        </td>

                        <td style="text-align:right;">
                            <template v-if="property.isConfirmed">
                                <i data-toggle="tooltip" data-placement="top" title="Activated" style="margin-right:6px;display:inline-block;" class="btn btn-table fas fa-check"></i>
                            </template>
                            <template v-else>
                                <a v-if="property.pendingConfirmed" data-toggle="tooltip" data-placement="top" title="Resend Activation" style="margin-right:6px;display:inline-block;" class="btn btn-table" @click.prevent="activateProperty(property)"><i style="color: rgb(0, 125, 252);" class="fas fa-circle"></i></a>
                                <a v-else data-toggle="tooltip" data-placement="top" title="Send Activation" style="margin-right:6px;display:inline-block;" class="btn btn-table" @click.prevent="activateProperty(property)"><i class="fas fa-circle"></i></a>
                            </template>
                            <router-link style="display:inline-block;" class="btn btn-table" :to="{
                    name: 'property',
                    params: { propertyId: property.id,
                      buildingId: buildingId, buildingName: buildingName },
                  }"><i class="fas fa-pen"></i></router-link>
                            <router-link style="display: inline-block;margin-left:6px;" data-toggle="tooltip" data-placement="top" title="Receipts" class="btn btn-table" :to="{
                    name: 'payments',
                    params: {
                      propertyId: property.id,
                      buildingId: buildingId,
                      buildingName: buildingName,
                      propertyName: property.propertyName,
                    },
                  }"><i class="fas fa-receipt"></i></router-link>
                            <router-link style="display: inline-block; margin-left: 6px;" data-toggle="tooltip" data-placement="top" title="Invoices" class="btn btn-table" :to="{
                    name: 'invoices',
                    params: {
                      propertyId: property.id,
                      buildingId: buildingId,
                      buildingName: buildingName,
                      propertyName: property.propertyName,
                    },
                  }"><i class="fas fa-file-invoice"></i></router-link>

                            <a style="margin-left:6px;display:inline-block;" class="btn btn-table" @click.prevent="deleteItem(property)"><i class="fas fa-times"></i></a>

                        </td>
                    </tr>

                    <!--<tr v-bind:key="property"
                        class="clickable-row second"
                        v-bind:class="{ 'hide-row': !property.isSelected }">
                        <td scope="row"
                            colspan="7"
                            class="clickable-column"
                            style="border: none; text-align: right;">
                            <router-link class="btn btn-primary"
                                         style="display: inline-block; width: 90px; color: #fff;"
                                         :to="{
                    name: 'property',
                    params: { propertyId: property.id,
                      buildingId: buildingId, buildingName: buildingName },
                  }">Edit</router-link>

                            <router-link class="btn btn-edit"
                                         style="
                    display: inline-block;
                    width: 90px;
                    margin-left: 6px;
                    color: #fff;
                  "
                                         :to="{
                    name: 'payments',
                    params: {
                      propertyId: property.id,
                      buildingId: buildingId,
                      buildingName: buildingName,
                      propertyName: property.propertyName,
                    },
                  }">Receipts</router-link>

                            <a class="btn btn-delete"
                               style="
                    width: 90px;
                    margin-left: 6px;
                    display: inline-block;
                    color: #fff;
                  "
                               @click.prevent="deleteItem(property)">Delete</a>
                        </td>
                    </tr>-->
                </template>
            </tbody>
        </table>
    </div>

    <!-- MODAL IS HERE -->
    <modal :scrollable="true"
           name="deleteAlert"
           @before-open="beforeOpen"
           height="auto"
           :minHeight="150"
           width="400">
        <div class="" role="document">
            <div class="">
                <!-- Modal content-->
                <deleteAlert v-on:close="modalClosed"
                             :entity-id="selectedPropertyId"
                             request="properties"
                             entity="property" />
            </div>
        </div>
    </modal>
    <div class="row">
        <div class="col-8 table-summary">
            <span>
                Showing {{ startEntry }} to {{ endEntry }} of
                {{ numberOfEntries }} entries
            </span>
        </div>
        <div class="col-4">
            <paginate :page-count="numberOfPages"
                      :page-range="3"
                      :margin-pages="2"
                      :click-handler="clickCallback"
                      :prev-text="'<'"
                      :next-text="'>'"
                      :container-class="'pagination'"
                      :page-class="'page-item'">
            </paginate>
        </div>
    </div>

    <div class="clearfix"></div>
    </div>
</template>
<style scoped></style>
<script>
import { EventBus } from "@/events";
import { authenticationService } from "@/_services";
    
    import { mapState, mapActions } from "vuex";
export default {
  data: function () {
    return {
      size: 10,
      sortBy: "Name",
      filter: "",
      properties: [],
      contacts: [],
      currentUser: null,
      //numberOfAllowedBuildings : 0,
      role: "",
      buildingId: 0,
      //buildingName: "",
      pageNumber: 0,
      buttonsVisible: false,
      selectedPropertyId: 0,
      visibleSearch: false,
    };
  },
  // created(){
  //         EventBus.$on('menuDrawerClicked', (drawer)=>{
  //             this.drawer=drawer
  //         })
  //     },
  watch: {
    value(val) {
      this.$emit("update:buildingId", val);
      },
      buildingName(newBuildingName, oldBuildingName) {
          console.log(`We have ${newBuildingName} fruits now, yay!`)
      },
      building(newBuilding, oldBuilding) {

      },
    buildingId(val) {
      this.value = val;
      this.fetchStatement();
    },
  },
  created() {
    authenticationService.currentUser.subscribe((x) => (this.currentUser = x));

    // EventBus.$on('menuDrawerClicked', (drawer)=>{
    //     this.drawer=drawer
    // })
  },
  mounted() {
    //  this.buildingId = this.$route.params.buildingId;
    this.buildingId = this.$route.params.buildingId;
    this.emitGlobalClickEvent();
    //  this.buildingName = this.$route.params.buildingName;
    console.log("Buidling name : " + this.buildingName)
    //this.$data.buildingId = this.buildingId;
      if (this.$route.params.building != null) {
       //   console.log("b")
          this.$store.commit('building/SET_CURRENT_BUILDING', this.$route.params.building)
      }
      else {
         // console.log("a")
          this.fetchBuilding(this.buildingId);
      }
    this.fetchStatement();
  },
        methods: {
            ...mapActions("building", ["fetchBuilding"]),
    showSearch() {
      this.visibleSearch = !this.visibleSearch;
    },
    selectProperty(property) {
     // property.isSelected = !property.isSelected;
    },
    emitGlobalClickEvent() {
      // Send the event on a channel (i-got-clicked) with a payload (the click count.)
      EventBus.$emit("updated", this.buildingId);
    },
    fetchStatement: function () {
      this.mute = true;
      //this.buildingId = 3;
      var request = "/properties/building?id=" + this.buildingId;
      this.$http
        .get(request, {
          id: this.buildingId,
        })
        .then(({ data }) => {
          this.mute = false;
          //this.contacts = data.contacts;
          this.properties = data;
        });
    },

    clickCallback(pageNum) {
      this.pageNumber = pageNum - 1;
    },

    modalClosed: function (propertyDeleted) {
      if (propertyDeleted) this.fetchStatement();
      },
      activateProperty(item) {
          this.$http
              .post("/properties/activateProperty?id="+item.id, )
              .then(
                  () => {
                    item.pendingConfirmed = true
                      /*this.$router.push({
                          name: "properties",
                          params: { buildingId: this.buildingId },
                      })*/;
                  },
                  () => {
                      alert("error");
                      //  this.infoError = true
                      //  this.loader = false
                      //   this.password = ''
                  }
              )
      },
    deleteItem: function destroy(item) {
      this.selectedPropertyId = item.id;
      this.deleteAlert();
    },

    deleteAlert: function () {
      this.$modal.show("deleteAlert");
    },
  },

  computed: {
    ...mapState({
      building: (state) => state.building.currentBuilding,
      buildings: (state) => state.building.buildings,
      numberOfAllowedBuildings: (state) =>
        state.building.numberOfAllowedBuildings,
    }),
    buildingName(){
      if(this.building != null)
        return  this.building.name;
      return ""
    },
    getProperties() {
      if (!this.properties) return null;
      var properties = this.properties.filter((property) => {
        return property.propertyName
          .toLowerCase()
          .includes(this.filter.toLowerCase());
      });

      return properties;
    },

    numberOfEntries() {
      return this.getProperties.length;
    },

    numberOfPages() {
      let l = this.numberOfEntries,
        s = this.size;
      return Math.ceil(l / s);
    },
    startEntry() {
      if (this.numberOfEntries == 0) {
        return 0;
      }
      if (this.pageNumber + 1 == 1) {
        return 1;
      } else {
        return this.pageNumber * this.size + 1;
      }
    },
    endEntry() {
      if (this.numberOfEntries <= this.size) {
        return this.numberOfEntries;
      } else if (this.numberOfEntries > this.size && this.pageNumber + 1 == 1) {
        return this.size;
      } else if (this.numberOfEntries > this.size && this.pageNumber + 1 > 1) {
        if (this.numberOfEntries - this.size * (this.pageNumber + 1) > 0) {
          return this.size * (this.pageNumber + 1);
        } else {
          return this.numberOfEntries;
        }
      } else {
        return NaN;
      }
    },

    paginatedData() {
      const start = this.pageNumber * this.size,
        end = start + this.size;
      var properties = [...this.getProperties];
      if (this.sortBy == "Name") {
        properties.sort((a, b) =>
          a.propertyName.toLowerCase() > b.propertyName.toLowerCase()
            ? 1
            : b.propertyName.toLowerCase() > a.propertyName.toLowerCase()
            ? -1
            : 0
        );
      } else {
        properties.sort((a, b) =>
          a.contact.name.toLowerCase() > b.contact.name.toLowerCase()
            ? 1
            : b.contact.name.toLowerCase() > a.contact.name.toLowerCase()
            ? -1
            : 0
        );
      }
      return properties.slice(start, end);
    },
  },
}; // Our Javascript logic
</script>
